export default "__VITE_ASSET__9ba3415b__"